module.exports = __webpack_public_path__ + "vco-icons.8402c93e00aa667edece.ttf";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/storymap/icons/vco-icons.ttf
// module id = ../../../../../src/styles/storymap/icons/vco-icons.ttf
// module chunks = styles